import React, { ReactNode } from "react";
import {observer} from "mobx-react";
import FontBody1 from "../../../../../../fonts/font-body1/font-body1";
import MerchantPortalMenuItemStore from "../../merchant-portal-menu-item-store";
import { FONT_COLOR } from "../../../../../../fonts/font-props";

type GroupProps = {
    children: ReactNode;
    mainPortal: MerchantPortalMenuItemStore;
};

const Group: React.FC<GroupProps> = observer(({mainPortal, children}) => {
    return (
        <>
            <div
                className="portal-selection__group"
            >
                <div className="portal-selection__group__heading">
                    <FontBody1 color={FONT_COLOR.PRIMARY2}>{mainPortal.label} ({mainPortal.portals.length})</FontBody1>
                </div>
                {children}
            </div>
        </>
    )
});

export default Group;